import { ACMEResponse, ACMEListResponse, TODO } from '@b2b/types/core';
import { IInjectable, StateParams } from '@uirouter/angularjs';
import { IPromise } from 'angular';
import { ApiService } from '../services/api/types';
import {MembershipListData, MembershipLifecycleActionForm } from '@b2b/types/membership';

export function MembershipsListDataResolver(
  props = {
    salesChannels: 'online,insideSalesIndividual,pointOfSale,reseller,manualEntry,customerRep',
    isPublished: 1,
    summarize: 1,
    pageSize: '-1',
    page: 1,
    sortField: 'name',
    sortDirection: 'asc',
  }
): IInjectable {
  return [
    'ApiService',
    function MembershipsListData(apiService: ApiService): IPromise<{ data: ACMEListResponse<MembershipListData> }> {
      return apiService.membership.categories.list(props);
    },
  ];
}

export function MembershipLifecycleActionFormListDataResolver(
  props = {
    page: '1',
    pageSize: '100',
  }
): IInjectable {
  return [
    'ApiService',
    '$stateParams',
    function MembershipLifecycleActionFormListData(
      apiService: ApiService
    ): IPromise<{ data: ACMEListResponse<MembershipLifecycleActionForm> }> {
      return apiService.membership.lifecycle.forms.list(props);
    },
  ];
}

export function MembershipLifecycleActionFormDataResolver(): IInjectable {
  return [
    'ApiService',
    '$stateParams',
    function MembershipLifecycleActionFormData(
      apiService: ApiService,
      $stateParams: StateParams
    ): IPromise<{ data: TODO }> {
      return apiService.membership.lifecycle.forms.detail({ id: $stateParams.id });
    },
  ];
}
